/** Indicador de tab activo con gradiente de marca */
export default function TabIndicator() {
  return (
    <div className="absolute bottom-0 left-0 right-0 h-1 gfi-gradient-bg rounded-t-full shadow-tab-indicator" />
  );
}
